import { Button } from "@components/ui/button"
import { ExternalLink, Loader2 } from "lucide-react"
import { useGetTermsQuery } from "@apis/terms/useTerms"
import { toast } from "sonner"

interface TViewTermsButtonProps {
  termsArchiveLoc: string | null
}

export const ViewTermsButton = ({ termsArchiveLoc }: TViewTermsButtonProps) => {
  const { isFetching, refetch } = useGetTermsQuery(termsArchiveLoc)

  // For a better UX, disable the button if termsArchiveLoc is null
  if (!termsArchiveLoc)
    return (
      <Button size="icon" variant="ghost" disabled={true}>
        <ExternalLink className="tw:h-4 tw:w-4" />
      </Button>
    )

  const handleClick = async () => {
    const res = await refetch()
    if (res.isSuccess) {
      window.open(res.data as string, "_blank", "noopener,noreferrer")
    }
    if (res.isError) {
      toast.error(`Error fetching terms! ${res.error}`)
    }
  }

  return (
    <Button
      size="icon"
      variant="ghost"
      onClick={handleClick}
      disabled={isFetching}
    >
      {isFetching ? (
        <Loader2 className="tw:h-4 tw:w-4 tw:animate-spin" />
      ) : (
        <ExternalLink className="tw:h-4 tw:w-4" />
      )}
    </Button>
  )
}
